import { jsx as _jsx } from "react/jsx-runtime";
var ColorPicker = function ColorPicker(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.056 10.642 13.36 7.946l1.912-1.911 2.694 2.694-1.91 1.913Zm-6.977 6.983-2.976.27.264-2.955 5.579-5.58 2.696 2.696-5.563 5.569ZM19.403 7.337l-2.74-2.74c-.767-.767-1.986-.795-2.714-.067l-2.003 2.002-1.24-1.24a1 1 0 0 0-1.413 1.415l1.239 1.239-5.58 5.58a1.977 1.977 0 0 0-.57 1.214l-.378 4.17a1.002 1.002 0 0 0 1.087 1.086l4.17-.378a1.979 1.979 0 0 0 1.214-.57l5.58-5.58 1.238 1.239A.995.995 0 0 0 18 15a.999.999 0 0 0 .707-1.707l-1.238-1.238 2.002-2.003c.73-.73.699-1.947-.068-2.715Z",
      fill: color
    })
  });
};
export default ColorPicker;